<template lang="pug">
  v-row(justify='center')
    v-dialog(v-model='openModal' persistent='' max-width='650')
      v-form(ref="form" v-model="valid" lazy-validation) 
      v-card( style="padding:10px")
        v-card-title(style="background-color:#F3F4F6;margin:-10px -10px 0 -10px")
          span(style="margin-left:-10px;margin-bottom:10px") Tambah Tindakan 
        v-card-text()           
          v-layout(row wrap)              
              v-flex(xs7 sm12 style="margin-top:20px")
                  span Nama Tindakan
                  v-text-field(style="margin-top:10px" v-model="dataTindakan.titleTindakan" class="inputDefault"  label="Tulis"  single-line outlined)
              v-flex(xs7 sm12 style="margin-top:-20px")
                  span Oleh
                  v-menu(
                  v-model="searchPemegangMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px")
                
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        v-model="dataTindakan.penanggungJawab.name"
                        label="Oleh"
                        id="fikp-pemegang-izin1"
                        readonly
                        single-line 
                        outlined
                        v-on="on")
                    PemegangModal(:searchPemegang="searchPemegangMenu" @interface="searchPemegangMenu = false" @selectedUser="updatePemegangIzin" ref="clearPemegang")
              v-flex(xs7 sm12 style="margin-top:-20px")
                  span Tanggal 
                  label(style="font-size:12px") (maks 1 bulan)
                  v-menu(
                    v-model="startMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px")
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        v-model="dataTindakan.deadline"
                        label="Tanggal"
                        prepend-inner-icon="event"
                        style="margin-top:10px"
                        single-line outlined
                        readonly
                        v-on="on")
                    v-date-picker(v-model="dataTindakan.deadline" @input="clearDate" :min="todayDate" :max="maxDate" single-line outlined)
              v-flex(xs7 sm12 style="margin-top:-20px")
                  span Status
                  v-select(style="margin-top:10px"  :items='statusOptions' v-model="dataTindakan.statusTindakan" label="Pilih" single-line outlined) 
              v-flex(xs7 sm12 style="margin-top:-20px")
                  span Lampiran
                  div(style="margin-top:10px" class="attachment" v-if="!docLampiran || docLampiran.size > 10000000")
                    v-file-input(prepend-icon="" prepend-inner-icon="mdi-plus" :rules="rules"  label="Lampiran" v-model="docLampiran" single-line outlined)
                        template(v-slot:selection="{ text }" )
                            v-chip(small label color="primary")   {{ text }}
                  div(style="margin-top:10px" class="attachmentName" v-else)
                    span(id="firt-document") {{docLampiran.name ? docLampiran.name : docName(docLampiran) }}
                    v-btn(icon color="red" @click="deleteDocLampiran('docPendukung')")
                        v-icon mdi-close

        v-card-actions(style="margin-top:10px")
          v-spacer
          v-btn(
            color="blue darken-1"
            text
            @click='handleClose()'
          ) Cancel
          v-btn(
            v-if="this.dataTindakan.statusTindakan == 'CLOSE'"
            color="primary"
            style="margin-left:10px;width:20%"
            @click='actionSave'
            :disabled="!isStatusClose"
          ) Submit
          v-btn(
            v-else
            color="primary"
            style="margin-left:10px;width:20%"
            @click='actionSave'
            :disabled ="!isStatusNotClose"
          ) Submit
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import PemegangModal from "../PemegangModal.vue";
export default {
  name: "ModalTindakan",
  props: ['openModal','onClose'],
  components: {
    PemegangModal
  },
  data () {
    return {
      valid: true,
      startDate: "",
      startMenu: false,
      docLampiran:null,
      searchPemegangMenu: false,
      dataTindakan : {
        titleTindakan:"",
        penanggungJawab: {},
        statusTindakan:"OPEN",
        deadline:"",
        lampiranUploadId:"",
        lampiran: {},
        description: ""
      },
      statusOptions :["OPEN", "CONTINUE","CLOSE"],
      rules: [
        value => !value || value.size < 10000000 || 'Ukuran file harus dibawah 10 MB!',
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      todayDate: new Date().toISOString().slice(0, 10),
      maxDate: new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10)
    }
  },
  computed: {
    ...mapState(["API_URL"]),
    
    isStatusClose: function () {
      return (
        this.docLampiran && this.dataTindakan.titleTindakan && this.dataTindakan.penanggungJawab && this.dataTindakan.deadline
      );
    },
    isStatusNotClose: function () {
      return (
        this.dataTindakan.titleTindakan && this.dataTindakan.penanggungJawab && this.dataTindakan.deadline
      );
    },
  },
  mounted() {
  },
  methods: {
    clearForm(){
      this.dataTindakan = {
        titleTindakan:"",
        penanggungJawab: {},
        statusTindakan:"OPEN",
        deadline:"",
        lampiranUploadId:"",
        lampiran: {},
        description: ""
      }
      this.docLampiran = null
    },
    updatePemegangIzin(user) {
      this.dataTindakan.penanggungJawab.name = user.name;
      this.dataTindakan.penanggungJawab.email = user.email;
      this.dataTindakan.penanggungJawab.nik = user.nik;
    },
    handleClose(){
      this.clearForm()
      this.$emit("onClose", false)
      this.$refs.clearPemegang.clearData();
    },
    clearDate() {
      this.startMenu = false;
    },
    docName(name){
      return this.$setFilename(name);
    },
    deleteDocLampiran(name){
      let id = this.dataTindakan.lampiranUploadId;      
      this.$store
        .dispatch("deleteFile", {
            uploadId: id,
            folderName: name,
        })
        .then(() => {
          this.docLampiran = null;
          this.dataTindakan.lampiranUploadId =  ""
          this.dataTindakan.lampiran = {}
        })
        .catch(() => {
            this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    actionSave(){
      this.$refs.form.validate();
      if(this.$refs.form.validate() === true) {
        this.$emit( 'handleSaveData', this.dataTindakan );
        setTimeout(() => {
          this.clearForm()
          this.$emit("onClose", false)
          this.$refs.clearPemegang.clearData();
        }, 300);
      }
    }
  },
  watch :{
    docLampiran(params){
      if(params && params.size < 10000000){
        let formData = new FormData();
        formData.append('uploadId', Date.now() );
        formData.append('docPendukung', params );
        axios.post(`${this.API_URL}/v1/requests/attachment/docPendukung`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}})
        .then(res =>{
           this.dataTindakan.lampiranUploadId = res.data.uploadId
           this.dataTindakan.lampiran.docPendukung = res.data.file.filename
        })
      }
    }
  }
}
</script>

<style>

</style>